import {KM_TO_REFETCH} from 'presentation/modules/booking/shared/constants/unitsInfo';
import {GetNetworkVisibilityParams} from './types';

const getNetworkVisibility = ({
	isGndiSaoPaulo,
	showEmptyAppointmentsCard,
	isSelfNetwork,
	notFoundUnits,
	notFoundAccreditedUnits,
	localityDistance,
	hasUnitsUpToMaxDistance,
	showAccreditedNetworkToHap,
	isFavoriteDoctorsFlow,
}: GetNetworkVisibilityParams) => {
	if (isFavoriteDoctorsFlow) {
		return {
			showSelfNetwork: true,
			showAccreditedNetwork: false,
		};
	}

	if (isGndiSaoPaulo || showAccreditedNetworkToHap) {
		return {
			showSelfNetwork: true,
			showAccreditedNetwork: true,
		};
	}

	if (showEmptyAppointmentsCard) {
		return {
			showSelfNetwork: true,
			showAccreditedNetwork: false,
		};
	}

	const hasReachedRefetchDistance =
		Number(localityDistance) >= Number(KM_TO_REFETCH) || !hasUnitsUpToMaxDistance;

	const showAccreditedNetwork =
		(!isSelfNetwork || (isSelfNetwork && notFoundUnits)) &&
		!notFoundAccreditedUnits &&
		hasReachedRefetchDistance;

	return {
		showSelfNetwork: !showAccreditedNetwork,
		showAccreditedNetwork,
	};
};

export {getNetworkVisibility};
